module.exports = __webpack_public_path__ + "img/Card-contactless.1a755605.svg";